import { render } from "./SelectField.vue?vue&type=template&id=cbf04ee0"
import script from "./SelectField.vue?vue&type=script&lang=js"
export * from "./SelectField.vue?vue&type=script&lang=js"
script.render = render

export default script